import { render } from "./Spinner.vue?vue&type=template&id=34bb277c"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "34bb277c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34bb277c', script)) {
    api.reload('34bb277c', script)
  }
  
  module.hot.accept("./Spinner.vue?vue&type=template&id=34bb277c", () => {
    api.rerender('34bb277c', render)
  })

}

script.__file = "resources/js/UI/Spinner.vue"

export default script